/**
 * 文本编辑「浮层」相关 DOM：编辑 overlay、portaled 工具条、HeroUI Select/Popover。
 * 用于 blur 与外部点击判断，避免误 commit / 卸载工具条。
 */
export const TEXT_EDIT_CHROME_SELECTOR = [
  '[data-text-edit-overlay]',
  '[data-text-edit-chrome]',
  '[data-workspace-text-toolbar]',
  '[data-workspace-text-toolbar-overlay]',
  '[data-text-properties-panel]',
  '[data-slot="popover-root"]',
  '[data-slot="popover-trigger"]',
  '[data-slot="popover-dialog"]',
  '[data-slot="popover-content"]',
  '[data-slot="popover-overlay-arrow"]',
  '[role="listbox"]',
  '[role="option"]',
  '[data-overlay-container]',
  '[data-react-aria-top-layer]',
].join(', ');

export function isWithinTextEditChrome(node: Node | null | undefined): boolean {
  if (!node || !(node instanceof Element)) return false;
  return Boolean(node.closest(TEXT_EDIT_CHROME_SELECTOR));
}
